import { decode } from 'he';
import striptags from 'striptags';

export const stripAndDecodeHtml = (text: string | undefined): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  try {
    const withBreaks = text
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(p|div|li|h[1-6]|tr|blockquote)>/gi, '\n');
    const stripped = striptags(withBreaks)
      .replace(/\n{3,}/g, '\n\n')
      .trim();
    return decode(stripped);
  } catch {
    return text;
  }
};
